import React, { useEffect, useState } from "react";
import axiosConfig from "../../Service/axiosConfig";
import { MdDeleteOutline } from "react-icons/md";
import DataTable from "react-data-table-component";
import { DeletePopupModal, PopupModal } from "../../Components";
import AlertDeletePopupModal from "../../Components/PopupModal/AlertDeletePopupModal";
import "../../Pages/master_categories.css";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdDelete,
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { FaHandHoldingHeart } from "react-icons/fa";
import Select from "react-select";
import tableCustomStyles from "../PopupModal/tableCustomStyles";

const CategoryGroupingSection = ({
  id,
  selectedhomepageId,
  categoryGroupingSecId,
  is_suspended,
  getTemplate,
}) => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [RowPerPage, setRowPerPage] = useState(20);
  const [Error, SetError] = useState();
  const [popupType, setpopupType] = useState("");
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [Message, SetMessage] = useState("");
  const [groupingOptions, setGroupingOptions] = useState([]);
  const [selectedGroupings, setSelectedGroupings] = useState([]);

  // Fetch all available category groupings for the dropdown
  const fetchGroupings = async () => {
    try {
      const response = await axiosConfig.get(
        "/cms/category_grouping/?page_size=200&is_suspended=false"
      );
      setGroupingOptions(
        response.data.results.map((item) => ({
          value: item.id,
          label: item.title,
        }))
      );
    } catch (error) {
      console.error("Error fetching category groupings:", error);
      setGroupingOptions([]);
    }
  };

  // Fetch currently saved groupings for this section
  const GetData = async (sectionId = categoryGroupingSecId) => {
    if (!sectionId) return;
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/cms/get_homepagedesign/?section_id=${sectionId}`
      );
      const flattenedGroupings = (response?.data?.results || []).flatMap(
        (section) =>
          (section?.category_grouping || []).map((grp) => ({
            ...grp,
            section_id: section.id,
            section_title: section.title,
          }))
      );
      SetData(flattenedGroupings);
      setTotalRows(flattenedGroupings.length);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroupings();
  }, []);

  useEffect(() => {
    if (categoryGroupingSecId) {
      GetData(categoryGroupingSecId);
    }
  }, [categoryGroupingSecId]);

  const handleGroupingChange = (selectedOptions) => {
    setSelectedGroupings(selectedOptions);
  };

  const handleSaveSelected = async () => {
    if (!selectedGroupings.length) return;

    const selectedIds = selectedGroupings.map((item) => item.value);

    try {
      if (categoryGroupingSecId) {
        await axiosConfig.post(
          `/cms/homepage_template/${categoryGroupingSecId}/add_items/`,
          {
            item_type: "category_grouping",
            item_ids: selectedIds,
          }
        );
        await GetData(categoryGroupingSecId);
        await getTemplate();
      } else {
        const response = await axiosConfig.post("/cms/homepage_template/", {
          home_page: selectedhomepageId,
          title: "Category Grouping",
          category_grouping: selectedIds,
          sort: id,
        });
        const newSectionId = response?.data?.id;
        if (newSectionId) {
          await GetData(newSectionId);
          await getTemplate();
        }
      }
      SetMessage("Category Grouping saved successfully");
      setpopupType("success");
    } catch (error) {
      SetError("Error saving category grouping template");
      setpopupType("error");
      console.error(error);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Title",
      selector: "title",
      cell: (row) => row.title,
      sortable: true,
    },
    {
      name: "Categories",
      selector: "category",
      cell: (row) =>
        (row.categories || row.category || [])
          .map((cat) =>
            typeof cat === "object" && cat !== null ? cat.name : cat
          )
          .join(", "),
      sortable: false,
    },
    {
      name: "Sort",
      selector: "sort",
      cell: (row) => row.sort,
      sortable: true,
    },
    {
      name: "Section Title",
      selector: "section_title",
      cell: (row) => row.section_title,
      sortable: true,
    },
    {
      name: "ACTIONS",
      selector: (row) => {
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (deleteId) => {
          try {
            if (categoryGroupingSecId) {
              await axiosConfig.post(
                `/cms/homepage_template/${categoryGroupingSecId}/remove_items/`,
                {
                  item_type: "category_grouping",
                  item_ids: deleteId,
                }
              );
            }
            SetAlertDeletePopupType("error");
            setDeletepopupType("success");
            await GetData();
            setTimeout(() => {
              getTemplate();
            }, 300);
          } catch (error) {
            setDeletepopupType("error");
            SetAlertDeletePopupType("error");
            console.error("Error deleting category grouping:", error);
          }
        };

        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : null}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];

  const SectionDelete = async () => {
    try {
      await axiosConfig.delete(
        `/cms/homepage_template/${categoryGroupingSecId}/`
      );
      SetMessage("Category Grouping template deleted successfully");
      setpopupType("success");
      await getTemplate();
    } catch (error) {
      SetError("Error deleting Category Grouping template");
      setpopupType("error");
      console.error(error);
    }
  };

  const handleReviveSection = async () => {
    try {
      await axiosConfig.post(
        `/cms/homepage_template/${categoryGroupingSecId}/revive/`
      );
      setpopupType("success");
      SetMessage("Category Grouping section revived successfully");
      await GetData();
      await getTemplate();
    } catch (error) {
      SetError("Error while reviving Category Grouping section");
      setpopupType("error");
      console.error("Revival error:", error);
    }
  };

  return (
    <>
      <div className="child-sidenav">
        <div className="childnav-content">
          <div className="text-block-end border-remove">
            <div className="text-block-border">
              <h5 className="dashboard-subtitle">Category Grouping Section</h5>

              <div className="d-flex gap-4">
                {!is_suspended ? (
                  <>
                    <MdKeyboardArrowUp />
                    <MdKeyboardArrowDown />
                    <FiSave
                      size={24}
                      onClick={handleSaveSelected}
                      style={{ cursor: "pointer" }}
                    />
                    <MdDelete
                      style={{ cursor: "pointer" }}
                      size={24}
                      onClick={SectionDelete}
                    />
                  </>
                ) : (
                  <FaHandHoldingHeart
                    size={24}
                    onClick={handleReviveSection}
                    style={{ cursor: "pointer", color: "green" }}
                  />
                )}
              </div>
            </div>

            <div className="col-md-4 sub-filter mt-3">
              <Select
                options={groupingOptions}
                placeholder="Select Category Grouping"
                isMulti={true}
                onChange={handleGroupingChange}
                value={selectedGroupings}
              />
            </div>

            <div className="p-2">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Data}
                  pagination
                  paginationTotalRows={totalRows}
                  paginationPerPage={RowPerPage}
                  draggableColumns
                  paginationDefaultPage={currentPage}
                  customStyles={tableCustomStyles}
                  onChangePage={(page) => setCurrentPage(page)}
                  paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  onChangeRowsPerPage={(RowsPerPageChange) =>
                    setRowPerPage(RowsPerPageChange)
                  }
                  progressPending={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={Message}
          error={Error}
        />
      )}
      {deletePopupType && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
    </>
  );
};

export { CategoryGroupingSection };
